module.exports = __webpack_public_path__ + "img/qimingxing-mini-code.4f0d2596.png";